import { jwtDecode } from "jwt-decode";

export function jwtDecodeExp(token: string): number {
  const decoded: { exp: number } = jwtDecode(token);
  return decoded.exp;
}
